import { api } from "./client";
import type {
  Booking,
  Destination,
  Experience,
  Hotel,
  TokenPair,
  User,
  Vendor,
} from "@/types";

// --- Auth ---
export interface RegisterPayload {
  full_name: string;
  phone: string;
  email?: string;
  password: string;
  otp?: string;
}

export const authApi = {
  requestOtp: (phone: string) =>
    api.post<{ message: string }>("/auth/otp/request", { phone }),

  register: (payload: RegisterPayload) =>
    api.post<TokenPair>("/auth/register", payload),

  login: (identifier: string, password: string) =>
    api.post<TokenPair>("/auth/login", { identifier, password }),

  logout: () => api.post("/auth/logout"),

  me: () => api.get<User>("/users/me"),

  ekyc: (aadhaar_number: string, otp: string) =>
    api.post<User>("/auth/ekyc", { aadhaar_number, otp }),

  google: (access_token: string) =>
    api.post<TokenPair>("/auth/google", { access_token }),

  facebook: (access_token: string) =>
    api.post<TokenPair>("/auth/facebook", { access_token }),
};

// --- Destinations ---
export const destinationApi = {
  list: (featured?: boolean) =>
    api.get<Destination[]>("/destinations", {
      params: featured === undefined ? {} : { featured },
    }),
  get: (publicId: string) => api.get<Destination>(`/destinations/${publicId}`),
};

// --- Vendors / Bookings ---
export const vendorApi = {
  list: () => api.get<Vendor[]>("/vendors"),
};

export const bookingApi = {
  list: () => api.get<Booking[]>("/bookings"),
  create: (body: { destination_public_id?: string; service_public_id?: string; quantity?: number }) =>
    api.post<Booking>("/bookings", body),
  confirm: (booking_public_id: string, upi_vpa = "tourist@upi") =>
    api.post<Booking>("/bookings/confirm", { booking_public_id, upi_vpa }),
};

// --- AI ---
export const aiApi = {
  chat: (message: string, destination_public_id?: string) =>
    api.post<{ reply: string; sources: string[] }>("/ai/chat", {
      message,
      destination_public_id,
    }),
};

// --- Hotels (public, read-only) ---
export const hotelApi = {
  list: () => api.get<Hotel[]>("/hotels"),
};

// --- Experiences (public, read-only) ---
export const experienceApi = {
  list: (city?: string) => api.get<Experience[]>("/experiences", { params: city ? { city } : {} }),
  get: (publicId: string) => api.get<Experience>(`/experiences/${publicId}`),
};

// Admin endpoints live in the separate admin/ app (its own login, its own
// origin) — not bundled into the public site.
